import StepOne from "@/components/dashboard/depositMoney/StepOne";

export default function DepositMoneyStepOne() {
  return <StepOne />;
}
